// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationId } from './HarvestOperation';
import { harvestAttributeLineageId } from './HarvestAttributeLineage';
import { harvestOperationAttributeId } from './HarvestOperationAttribute';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestLegacyTabularSnapshotId = (z.string());
export const harvestLegacyTabularSnapshot = z.object({
    id: harvestLegacyTabularSnapshotId,
    harvest_operation_id: harvestOperationId,
    attribute_lineage_id: harvestAttributeLineageId,
    harvest_operation_attribute_id: harvestOperationAttributeId.nullable(),
    tabular_data: z.unknown(),
    archived_at: z.date(),
    operator_id: operatorId.nullable(),
    created_at: z.date(),
});
export const harvestLegacyTabularSnapshotInitializer = z.object({
    id: harvestLegacyTabularSnapshotId.optional(),
    harvest_operation_id: harvestOperationId,
    attribute_lineage_id: harvestAttributeLineageId,
    harvest_operation_attribute_id: harvestOperationAttributeId.optional().nullable(),
    tabular_data: z.unknown(),
    archived_at: z.date(),
    operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
});
export const harvestLegacyTabularSnapshotMutator = z.object({
    id: harvestLegacyTabularSnapshotId.optional(),
    harvest_operation_id: harvestOperationId.optional(),
    attribute_lineage_id: harvestAttributeLineageId.optional(),
    harvest_operation_attribute_id: harvestOperationAttributeId.optional().nullable(),
    tabular_data: z.unknown().optional(),
    archived_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=HarvestLegacyTabularSnapshot.js.map